import React, { useEffect, useState } from "react";
import CTable from "components/common/Table";
import { withRouter } from "react-router";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Switch from "../common/Switch";
import TextField from "components/common/TextField";
import Box from "components/common/Box";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import { Formik } from "formik";
import * as yup from "yup";
import Text from "components/common/Text";
import { Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import SearchBar from "components/common/SearchBar";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {FormControl,InputLabel,OutlinedInput,InputAdornment,} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import { NetworkTableApi } from "stores/ChargingNetworkStore/NetworkTableApi";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";


const ChargingNetworkList = ({
  submitCharging,
  loading,
  onClickEdit,
  data,
  handleStatusChargignNetwork,
  onChange,
  searchhandleChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  onPageChange,
  page,
  limit,
  totalCount,
  handleReset,
  handleDeleteChargignNetwork
}) => {

const [chargingnetworkBulk,setChargingNetworkBulk] =useState("")
  const classes = useStyles();
  const initialValues = {
    chargingname: "",
    file:null,
  };

  useEffect(() => {
    const fetchVehicleData = async () => {
        try {
            const limit = totalCount;
                const data = await NetworkTableApi.getNetworkBulkExportTable({ limit });
                
                setChargingNetworkBulk(data?.result?.networks); 
        } catch (error) {
            console.error("Error exporting Navigation data:", error);
        }
    };

        fetchVehicleData();
    }, [totalCount]);

    const downloadAsExcel = () => {
        const navigationData = chargingnetworkBulk.map((d) => ({
          'List of Charging Networks': d?.name,
        
        }));  
        const worksheet = XLSX.utils.json_to_sheet(navigationData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "charging network Data");
        XLSX.writeFile(workbook, "ChargingNetwork.xlsx");
      };

  const validateNetworkForm = yup.object().shape({
    chargingname: yup
      .string()
      .required("Charging network is required")
      .trim("Charging network cannot contain extra spaces")
      .strict(true)
      .matches(
        /[a-zA-Z0-9]+$/,
        "Only alphabets and number are allowed for this field "
      ),
      file: yup
      .mixed()
      .required("upload image in only jpeg/jpg/png format")
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });

  const columns = [
    {
      field: "name",
      headerName: "List of Charging Networks",
    },

    {
      field: "price",
      headerName: "Action",
      valueGetter: (v, d) => {
        return (
          <>
            {
              <>
                <EditOutlinedIcon
                  className={classes.icon}
                  onClick={() => {
                    onClickEdit(d?.id, d?.name);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#004AAD",
                    marginLeft: "36%",
                  }}
                />

                {
                  <Switch
                    checked={d.status === 1 ? true : false}
                    onClick={() => handleStatusChargignNetwork(d.id, d.status)}
                    sx={{ marginBottom: "20px",
                    cursor: "pointer",

                     }}
                  />
                }
                {
                  
                   <DeleteOutlineOutlinedIcon
                     sx={{ fontSize: "22px" ,color: "red",
                    cursor: "pointer",

                     }}
                     onClick={() => handleDeleteChargignNetwork(d.id)}

                   />
               
                }
              </>
            }
          </>
        );
      },
    },
  ];
  const sortedNetworks = (data?.networks ?? []).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values, { resetForm }) => {
            let formData = new FormData();
          formData.append("name", values.chargingname);
          formData.append("file", values.file);
          submitCharging(formData).then(() => {
            resetForm(); 
            document.getElementById("file").value = ""; 
          });
          // submitCharging(values);
          values.chargingname = "";
        }}
        validationSchema={validateNetworkForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          isValid,
          values,
          touched,
          errors,
          setFieldValue
        }) => (
          <>
            <Box sx={{display:'flex',justifyContent:'space-between'}}>
              <Text
                variant="h5"
                color="#707070"
                sx={{ fontSize: "22px", marginBottom: "40px" }}
              >
                Add Charging Networks
              </Text>
              <span
                onClick={() => downloadAsExcel()}
                className={classes.exportfile}
              >
                <FileDownloadIcon className={classes.fileDownload_icon} />
                Export Report
              </span>
            </Box>
            <Box
              sx={{ display: "flex",  justifyContent: "space-between" }}
            >
              <Box sx={{ maxWidth: 200, minWidth: 200 }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "14px" }}
                    className={classes.datePickerInput}
                    id="daterange-label"
                  >
                    Date Range
                  </InputLabel>
                  <OutlinedInput
                    sx={{ height: "37px",fontSize:'11px' }}
                    label="Date Range"
                    className={classes.table_date}
                    id="outlined-adornment-amount"
                    value={
                      fromat_date_from && fromat_date_to
                        ? `${fromat_date_from} - ${fromat_date_to}`
                        : ""
                    }
                    onClick={handleDatePickerOpen}
                    endAdornment={
                      <InputAdornment position="end" sx={{cursor:'pointer'}}>
                        <EventIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Box>
              <Dialog
                open={datePickerOpen !== undefined ? datePickerOpen : false}
                onClose={handleDatePickerClose}
                title="Select a date range"
                children={
                  <DatePickerModal
                    onClose={handleDatePickerClose}
                    onDatePickerSub={onDatePickerSub}
                    from_date={from_date}
                    to_date={to_date}
                    handleChange={onChange}
              handleReset={handleReset}

                  />
                }
              />
              <Box className={classes.searchBoxContainer}>
                <SearchBar
                  onSearchChange={(value) =>
                    searchhandleChange("inputsearch", value)
                  }
                />
              </Box>
            </Box>
            <Stack direction={"row"} spacing={37.5}>
            <Stack xs={6}>
              <Text sx={{ color: "#666666", fontSize: "14px", marginTop:'15px' }}>
                Enter Charging Network
              </Text>
              <Box className={classes.network} sx={{ width: "27rem" }}>
                <TextField
                  className={classes.networktext}
                  size="small"
                  sx={{ width: "19rem" }}
                  onBlur={handleBlur("chargingname")}
                  onChange={handleChange("chargingname")}
                  value={values.chargingname}
                  error={!touched.chargingname && Boolean(errors.chargingname)}
                />
                {errors.chargingname && (
                  <Typography sx={{ color: "red" }}>
                    {errors.chargingname}
                  </Typography>
                )}
              </Box>

            </Stack>

            <Stack  xs={6}>
                  <Text sx={{ color: "#666666", fontSize: "14px", marginTop:'15px' }}>
                  Add Network Image
              </Text>
                  <Box
                    className={classes.form_container}
                    // sx={{ marginTop: "-10px" }} 
                  >
                    <Box
                      sx={{
                        width: "300px",
                        height: "25px",
                        border: "1px solid rgba(0, 0, 0, 0.27)",
                        padding: "10px 10px",
                        borderRadius: "5px",
                      }}
                    >
                      <input
                        id="file"
                        name="photo"
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={(event) => {
                          setFieldValue("file", event.currentTarget.files[0]);
                        }}
                        error={!touched.file && Boolean(errors.file)}
                      />
                      {errors.file && (
                        <Typography sx={{ color: "red", margin: "15px -10px" }}>
                          {errors.file}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Stack>
                </Stack>

          
            <Stack mt={1.5}>
              <Button
                variant="outlined"
                sx={{
                  width: "94.17px",
                  height: "51.41px",
                  fontSize: "16px",
                  borderColor: "#0071C5",
                  color: "#0071C5",
                }}
                size="small"
                disabled={!isValid}
                onClick={() => {
                  handleSubmit();
                }}
              >
                + Add
              </Button>
            </Stack>
            <br></br>
            <CTable
              columns={columns}
              data={sortedNetworks??[]}
              isLoading={loading}
              pagination={true}
              page={page}
              rowsPerPage={limit}
              onPageChange={onPageChange}
              count={totalCount}
            ></CTable>
          </>
        )}
      </Formik>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  networktext: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  network: {
    "@media (max-width:768px)": {
      width: "100%",
    },
  },
  icon: {
    "@media (max-width:768px)": {
      marginLeft: "11px",
    },
  },
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    height: "25px",
    float: "right",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
  fileDownload_icon: {
    fontSize: "20px",
    marginTop: "3px",
  },
}));
export default withRouter(ChargingNetworkList);
